<template>
  <section-page
    title="Invoices"
    class="is-relative"
  >
    <app-loading-section
      :loading="loading"
      :count="invoices.length"
      heading="There are no past invoices"
    >
      <table-default
        :table-data="invoices"
        :default-sort="['date', 'desc']"
      >
        <b-table-column label="Date" field="date" sortable v-slot="props">
          {{ formatDate(props.row.period_end) }}
        </b-table-column>

        <b-table-column label="Status" field="status" v-slot="props">
          {{ props.row.status }}
        </b-table-column>

        <b-table-column label="Amount" field="amount" sortable v-slot="props">
          {{ props.row.total }}
        </b-table-column>

        <b-table-column label="Invoices" field="hosted_invoice_url" v-slot="props">
          <a :href="props.row.hosted_invoice_url" target="_blank">View</a>
        </b-table-column>
      </table-default>
    </app-loading-section>
  </section-page>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "AccountInvoices",
  data() {
    return {
      loading: true,
      invoices: [],
    };
  },
  methods: {
    formatDate(date) {
      return dates.formatAsDate(date)
    }
  },
  mounted() {
    this.$api.billing.getPastBillingInfo().then(response => {
      this.invoices = response.data;
      this.loading = false;
    });
  }
};
</script>
